var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropper",class:{active:_vm.thisDragOver},on:{"dragover":function($event){$event.preventDefault();return _vm.dragOver.apply(null, arguments)},"dragleave":function($event){$event.preventDefault();return _vm.dragLeave.apply(null, arguments)},"drop":function($event){$event.preventDefault();return _vm.drop($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }